import { Controller } from '@hotwired/stimulus'
import { renderStreamMessage } from '@hotwired/turbo'

export default class extends Controller {
  static targets = ['event', 'conditionsList', 'conditionTemplate']
  static values = { testUrl: String }

  connect() {
    this.renumber()
  }

  addCondition() {
    const fragment = this.conditionTemplateTarget.content.cloneNode(true)
    this.conditionsListTarget.appendChild(fragment)
    this.renumber()
  }

  checkValidity(event) {
    if (!this.element.reportValidity()) {
      event.preventDefault()
      event.stopPropagation()
    }
  }

  removeCondition(e) {
    e.target.closest('.condition-row')?.remove()
    this.renumber()
  }

  renumber() {
    this.conditionsListTarget.querySelectorAll('.condition-row').forEach((row, i) => {
      const badge = row.querySelector('.condition-number')
      if (badge) badge.textContent = i + 1
    })
  }

  async test() {
    const event = this.eventTarget.value
    const conditions = Array.from(this.conditionsListTarget.querySelectorAll('.condition-row')).map(row => ({
      path: row.querySelector('[data-role="path"]')?.value || '',
      pattern: row.querySelector('[data-role="pattern"]')?.value || ''
    }))

    try {
      const response = await fetch(this.testUrlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'text/vnd.turbo-stream.html',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || ''
        },
        body: JSON.stringify({ event, conditions })
      })
      renderStreamMessage(await response.text())
    } catch {
      // Network failure — result area retains its previous state
    }
  }
}
